export const ZERO = 0
export const ONE = 1
export const TWO = 2
export const THREE = 3

export const LONG_MAX_VALUE = BigInt('9223372036854775807') // 64-bit signed long maximum value
export const LONG_MAX_DIGITS = 19 // Maximum number of digits of 64-bit signed long

export const BOT_ID = '74'
export const TEMPLATE_ID = 4